<ngb-alert [type]="'danger'" *ngIf="errorMessage">
  {{ errorMessage }}
</ngb-alert>

<app-spinner *ngIf="isLoading"></app-spinner>

<div class="card" class="card" *ngIf="!isLoading && !edited">
  <div class="card-header" *ngIf="mode === 'create'">Nuevo vestido</div>
  <div class="card-header" *ngIf="mode === 'edit'">Editar vestido</div>
  <div class="card-body">
    <form (submit)="onSubmit(editForm)" #editForm="ngForm">
      <div class="row">
        <div class="col-md-6 col-sm-6 col-xs-12">
          <div class="mb-3">
            <label class="form-label">
              Fecha: <span class="text-danger">*</span>
            </label>
            <div class="input-group">
              <input
                class="form-control input-calendar"
                name="vestido_date_full"
                [(ngModel)]="vestido.vestido_date_full"
                ngbDatepicker
                #d="ngbDatepicker"
                (click)="d.toggle()"
              />
              <div class="input-group-append">
                <button
                  class="btn btn-outline-secondary fa fa-calendar"
                  (click)="d.toggle()"
                  type="button"
                ></button>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label class="form-label">
              Nº Aparición: <span class="text-danger">*</span>
            </label>
            <div class="form-group">
              <input class="form-control" type="number" />
            </div>
          </div>

          <div class="mb-3">
            <label class="form-label">
              Localización: <span class="text-danger">*</span>
            </label>
            <div class="form-group">
              <input
                class="form-control"
                type="text"
                placeholder="Localización"
              />
            </div>
            <div class="form-group">
              <select name="pais" class="form-control">
                <option value="AF">Afganistán</option>
                <option value="AL">Albania</option>
                <option value="DE">Alemania</option>
                <option value="AD">Andorra</option>
                <option value="AO">Angola</option>
                <option value="AI">Anguilla</option>
                <option value="AQ">Antártida</option>
                <option value="AG">Antigua y Barbuda</option>
                <option value="AN">Antillas Holandesas</option>
                <option value="SA">Arabia Saudí</option>
                <option value="DZ">Argelia</option>
                <option value="AR">Argentina</option>
                <option value="AM">Armenia</option>
                <option value="AW">Aruba</option>
                <option value="AU">Australia</option>
                <option value="AT">Austria</option>
                <option value="AZ">Azerbaiyán</option>
                <option value="BS">Bahamas</option>
                <option value="BH">Bahrein</option>
                <option value="BD">Bangladesh</option>
                <option value="BB">Barbados</option>
                <option value="BE">Bélgica</option>
                <option value="BZ">Belice</option>
                <option value="BJ">Benin</option>
                <option value="BM">Bermudas</option>
                <option value="BY">Bielorrusia</option>
                <option value="MM">Birmania</option>
                <option value="BO">Bolivia</option>
                <option value="BA">Bosnia y Herzegovina</option>
                <option value="BW">Botswana</option>
                <option value="BR">Brasil</option>
                <option value="BN">Brunei</option>
                <option value="BG">Bulgaria</option>
                <option value="BF">Burkina Faso</option>
                <option value="BI">Burundi</option>
                <option value="BT">Bután</option>
                <option value="CV">Cabo Verde</option>
                <option value="KH">Camboya</option>
                <option value="CM">Camerún</option>
                <option value="CA">Canadá</option>
                <option value="TD">Chad</option>
                <option value="CL">Chile</option>
                <option value="CN">China</option>
                <option value="CY">Chipre</option>
                <option value="VA">Ciudad del Vaticano (Santa Sede)</option>
                <option value="CO">Colombia</option>
                <option value="KM">Comores</option>
                <option value="CG">Congo</option>
                <option value="CD">Congo, República Democrática del</option>
                <option value="KR">Corea</option>
                <option value="KP">Corea del Norte</option>
                <option value="CI">Costa de Marfíl</option>
                <option value="CR">Costa Rica</option>
                <option value="HR">Croacia (Hrvatska)</option>
                <option value="CU">Cuba</option>
                <option value="DK">Dinamarca</option>
                <option value="DJ">Djibouti</option>
                <option value="DM">Dominica</option>
                <option value="EC">Ecuador</option>
                <option value="EG">Egipto</option>
                <option value="SV">El Salvador</option>
                <option value="AE">Emiratos Árabes Unidos</option>
                <option value="ER">Eritrea</option>
                <option value="SI">Eslovenia</option>
                <option value="ES" selected>España</option>
                <option value="US">Estados Unidos</option>
                <option value="EE">Estonia</option>
                <option value="ET">Etiopía</option>
                <option value="FJ">Fiji</option>
                <option value="PH">Filipinas</option>
                <option value="FI">Finlandia</option>
                <option value="FR">Francia</option>
                <option value="GA">Gabón</option>
                <option value="GM">Gambia</option>
                <option value="GE">Georgia</option>
                <option value="GH">Ghana</option>
                <option value="GI">Gibraltar</option>
                <option value="GD">Granada</option>
                <option value="GR">Grecia</option>
                <option value="GL">Groenlandia</option>
                <option value="GP">Guadalupe</option>
                <option value="GU">Guam</option>
                <option value="GT">Guatemala</option>
                <option value="GY">Guayana</option>
                <option value="GF">Guayana Francesa</option>
                <option value="GN">Guinea</option>
                <option value="GQ">Guinea Ecuatorial</option>
                <option value="GW">Guinea-Bissau</option>
                <option value="HT">Haití</option>
                <option value="HN">Honduras</option>
                <option value="HU">Hungría</option>
                <option value="IN">India</option>
                <option value="ID">Indonesia</option>
                <option value="IQ">Irak</option>
                <option value="IR">Irán</option>
                <option value="IE">Irlanda</option>
                <option value="BV">Isla Bouvet</option>
                <option value="CX">Isla de Christmas</option>
                <option value="IS">Islandia</option>
                <option value="KY">Islas Caimán</option>
                <option value="CK">Islas Cook</option>
                <option value="CC">Islas de Cocos o Keeling</option>
                <option value="FO">Islas Faroe</option>
                <option value="HM">Islas Heard y McDonald</option>
                <option value="FK">Islas Malvinas</option>
                <option value="MP">Islas Marianas del Norte</option>
                <option value="MH">Islas Marshall</option>
                <option value="UM">Islas menores de Estados Unidos</option>
                <option value="PW">Islas Palau</option>
                <option value="SB">Islas Salomón</option>
                <option value="SJ">Islas Svalbard y Jan Mayen</option>
                <option value="TK">Islas Tokelau</option>
                <option value="TC">Islas Turks y Caicos</option>
                <option value="VI">Islas Vírgenes (EEUU)</option>
                <option value="VG">Islas Vírgenes (Reino Unido)</option>
                <option value="WF">Islas Wallis y Futuna</option>
                <option value="IL">Israel</option>
                <option value="IT">Italia</option>
                <option value="JM">Jamaica</option>
                <option value="JP">Japón</option>
                <option value="JO">Jordania</option>
                <option value="KZ">Kazajistán</option>
                <option value="KE">Kenia</option>
                <option value="KG">Kirguizistán</option>
                <option value="KI">Kiribati</option>
                <option value="KW">Kuwait</option>
                <option value="LA">Laos</option>
                <option value="LS">Lesotho</option>
                <option value="LV">Letonia</option>
                <option value="LB">Líbano</option>
                <option value="LR">Liberia</option>
                <option value="LY">Libia</option>
                <option value="LI">Liechtenstein</option>
                <option value="LT">Lituania</option>
                <option value="LU">Luxemburgo</option>
                <option value="MK">Macedonia, Ex-República Yugoslava de</option>
                <option value="MG">Madagascar</option>
                <option value="MY">Malasia</option>
                <option value="MW">Malawi</option>
                <option value="MV">Maldivas</option>
                <option value="ML">Malí</option>
                <option value="MT">Malta</option>
                <option value="MA">Marruecos</option>
                <option value="MQ">Martinica</option>
                <option value="MU">Mauricio</option>
                <option value="MR">Mauritania</option>
                <option value="YT">Mayotte</option>
                <option value="MX">México</option>
                <option value="FM">Micronesia</option>
                <option value="MD">Moldavia</option>
                <option value="MC">Mónaco</option>
                <option value="MN">Mongolia</option>
                <option value="MS">Montserrat</option>
                <option value="MZ">Mozambique</option>
                <option value="NA">Namibia</option>
                <option value="NR">Nauru</option>
                <option value="NP">Nepal</option>
                <option value="NI">Nicaragua</option>
                <option value="NE">Níger</option>
                <option value="NG">Nigeria</option>
                <option value="NU">Niue</option>
                <option value="NF">Norfolk</option>
                <option value="NO">Noruega</option>
                <option value="NC">Nueva Caledonia</option>
                <option value="NZ">Nueva Zelanda</option>
                <option value="OM">Omán</option>
                <option value="NL">Países Bajos</option>
                <option value="PA">Panamá</option>
                <option value="PG">Papúa Nueva Guinea</option>
                <option value="PK">Paquistán</option>
                <option value="PY">Paraguay</option>
                <option value="PE">Perú</option>
                <option value="PN">Pitcairn</option>
                <option value="PF">Polinesia Francesa</option>
                <option value="PL">Polonia</option>
                <option value="PT">Portugal</option>
                <option value="PR">Puerto Rico</option>
                <option value="QA">Qatar</option>
                <option value="UK">Reino Unido</option>
                <option value="CF">República Centroafricana</option>
                <option value="CZ">República Checa</option>
                <option value="ZA">República de Sudáfrica</option>
                <option value="DO">República Dominicana</option>
                <option value="SK">República Eslovaca</option>
                <option value="RE">Reunión</option>
                <option value="RW">Ruanda</option>
                <option value="RO">Rumania</option>
                <option value="RU">Rusia</option>
                <option value="EH">Sahara Occidental</option>
                <option value="KN">Saint Kitts y Nevis</option>
                <option value="WS">Samoa</option>
                <option value="AS">Samoa Americana</option>
                <option value="SM">San Marino</option>
                <option value="VC">San Vicente y Granadinas</option>
                <option value="SH">Santa Helena</option>
                <option value="LC">Santa Lucía</option>
                <option value="ST">Santo Tomé y Príncipe</option>
                <option value="SN">Senegal</option>
                <option value="SC">Seychelles</option>
                <option value="SL">Sierra Leona</option>
                <option value="SG">Singapur</option>
                <option value="SY">Siria</option>
                <option value="SO">Somalia</option>
                <option value="LK">Sri Lanka</option>
                <option value="PM">St Pierre y Miquelon</option>
                <option value="SZ">Suazilandia</option>
                <option value="SD">Sudán</option>
                <option value="SE">Suecia</option>
                <option value="CH">Suiza</option>
                <option value="SR">Surinam</option>
                <option value="TH">Tailandia</option>
                <option value="TW">Taiwán</option>
                <option value="TZ">Tanzania</option>
                <option value="TJ">Tayikistán</option>
                <option value="TF">Territorios franceses del Sur</option>
                <option value="TP">Timor Oriental</option>
                <option value="TG">Togo</option>
                <option value="TO">Tonga</option>
                <option value="TT">Trinidad y Tobago</option>
                <option value="TN">Túnez</option>
                <option value="TM">Turkmenistán</option>
                <option value="TR">Turquía</option>
                <option value="TV">Tuvalu</option>
                <option value="UA">Ucrania</option>
                <option value="UG">Uganda</option>
                <option value="UY">Uruguay</option>
                <option value="UZ">Uzbekistán</option>
                <option value="VU">Vanuatu</option>
                <option value="VE">Venezuela</option>
                <option value="VN">Vietnam</option>
                <option value="YE">Yemen</option>
                <option value="YU">Yugoslavia</option>
                <option value="ZM">Zambia</option>
                <option value="ZW">Zimbabue</option>
              </select>
            </div>
          </div>

          <div class="mb-3">
            <label>
              Fotografías:
              <i
                class="fa fa-info-circle"
                aria-hidden="true"
                placement="top"
                ngbTooltip="Se debe incluir al menos una imagen en formato JPG o PNG. Es posible pulsar y arrastrar para modificar el orden de visualización."
              >
              </i>
              &nbsp;<span class="text-danger">*</span>
            </label>

            <div dragula="images" [(dragulaModel)]="vestido.images">
              <div *ngFor="let image of vestido.images; let i = index">
                <div class="row ingrediente imagen">
                  <div class="col-md-7 col-sm-12 col-xs-12">
                    <button
                      class="btn btn-light btn-image"
                      type="button"
                      (click)="imagePicker.click()"
                    >
                      <i class="fa fa-picture-o" aria-hidden="true"></i>&nbsp;
                      <span
                        *ngIf="vestido.images[i] && vestido.images[i].preview"
                        >Reemplazar</span
                      ><span
                        *ngIf="!vestido.images[i] || !vestido.images[i].preview"
                        >Seleccionar</span
                      >
                    </button>
                    <input
                      type="file"
                      accept="image/x-png,image/jpeg"
                      #imagePicker
                      (change)="onImagePicked($event, i)"
                      id="imagePicker_{{ i }}"
                    />

                    <div class="form-group">
                      <input
                        class="form-control"
                        type="number"
                        placeholder="Nº de foto"
                      />
                    </div>

                    <span class="btn btn-light" (click)="onDeleteImagen(i)"
                      ><i class="fa fa-trash-o"></i>
                      &nbsp;&nbsp;Eliminar
                    </span>
                  </div>

                  <div class="col-md-4 col-sm-12 col-xs-12 text-right">
                    <a
                      *ngIf="
                        vestido &&
                        vestido.images[i] &&
                        vestido.images[i].preview &&
                        vestido.images[i].preview.includes('http')
                      "
                      target="_blank"
                      href="{{ vestido.images[i].preview }}"
                    >
                      <img
                        src="{{
                          vestido.images[i].preview.replace(
                            '/images/',
                            '/images/l-'
                          )
                        }}"
                        [alt]="editForm.value.vestido_description"
                        class="img-thumbnail"
                      />
                    </a>
                    <img
                      *ngIf="
                        vestido &&
                        vestido.images[i] &&
                        vestido.images[i].preview &&
                        !vestido.images[i].preview.includes('http')
                      "
                      src="{{ vestido.images[i].preview }}"
                      [alt]="editForm.value.vestido_description"
                      class="img-thumbnail"
                    />

                    <!--<label class="btn btn-default file-input">
          Arrastrar o seleccionar <input type="file" hidden />
        </label>-->
                  </div>

                  <div class="col-md-1 col-sm-12 col-xs-12 text-center">
                    <i class="fa fa-sort" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
            </div>
            <button
              class="btn btn-light btn-add"
              *ngIf="this.vestido.images"
              [disabled]="
                !vestido.images[this.vestido.images.length - 1].preview
              "
              (click)="onAddImagen()"
            >
              <i class="fa fa-plus-circle"></i>&nbsp;&nbsp;Añadir otra imagen
            </button>
          </div>
        </div>

        <div class="col-md-6 col-sm-6 col-xs-12">
          <div class="col-md-12">
            <div
              *ngFor="let atuendo of vestido.atuendos; let i = index"
              class="row ingrediente"
            >
              <div class="col-md-12 col-sm-12 col-xs-12">
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control form-contro-sm"
                    name="atuendo_{{ i }}"
                    id="atuendo_{{ i }}"
                    placeholder="Especificar atuendo..."
                  />
                </div>
                <div
                  class="text-danger error"
                  *ngIf="
                    editForm.value['atuendo_' + i] &&
                    editForm.value['atuendo_' + i].includes(',')
                  "
                >
                  ¿Ha incluido más de un atuendo? Para una correcta indexación,
                  por favor, añada cada atuendo de forma individual haciendo
                  clic en "Añadir otro atuendo".
                </div>
              </div>
              <div class="col-md-8 col-sm-6 col-xs-12 pr-0">
                <div class="form-group">
                  <textarea
                    class="form-control"
                    [(ngModel)]="textarea"
                    name="textarea"
                    (ngModelChange)="parseTextArea()"
                    placeholder="Materiales (separados por comas)"
                  ></textarea>
                </div>
              </div>
              <div class="col-md-4 col-sm-6 col-xs-12 text-right">
                <span class="btn btn-light" (click)="onDeleteAtuendo(i)"
                  ><i class="fa fa-trash-o"></i>
                  &nbsp;&nbsp;Eliminar
                </span>
              </div>
            </div>

            <span
              class="btn btn-light btn-add"
              (click)="onAddAtuendo(editForm)"
            >
              <i class="fa fa-plus-circle"></i>&nbsp;&nbsp;Añadir otro atuendo
            </span>
          </div>

          <div class="col-md-12">
            <div
              *ngFor="let complemento of vestido.complementos; let i = index"
              class="row condimento"
            >
              <div class="col-md-12 col-sm-12 col-xs-12">
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control"
                    name="complemento_{{ i }}"
                    id="complemento_{{ i }}"
                    placeholder="Especificar complemento..."
                  />
                </div>
                <div
                  class="text-danger error"
                  *ngIf="
                    editForm.value['complemento_' + i] &&
                    editForm.value['complemento_' + i].includes(',')
                  "
                >
                  ¿Ha incluido más de un complemento? Para una correcta
                  indexación, por favor, añada cada complemento de forma
                  individual haciendo clic en "Añadir otro complemento".
                </div>
              </div>
              <div class="col-md-8 col-sm-6 col-xs-12">
                <div class="form-group">
                  <textarea
                    class="form-control"
                    name="textarea"
                    placeholder="Materiales (separados por comas)"
                  ></textarea>
                </div>
              </div>
              <div class="col-md-4 col-sm-6 col-xs-12 text-right">
                <span class="btn btn-light" (click)="onDeleteComplemento(i)"
                  ><i class="fa fa-trash-o"></i>
                  &nbsp;&nbsp;Eliminar
                </span>
              </div>
            </div>

            <span
              class="btn btn-light btn-add"
              (click)="onAddComplemento(editForm)"
            >
              <i class="fa fa-plus-circle"></i>&nbsp;&nbsp;Añadir otro
              complemento
            </span>
          </div>
        </div>

        <div class="col-md-12 save">
          <button type="submit" class="btn btn-success" [disabled]="true">
            <i class="fa fa-floppy-o" aria-hidden="true"></i>&nbsp;&nbsp;Guardar
          </button>
          <p *ngIf="true" class="text-danger">
            <!--* Para guardar,<br />rellene todos los<br />campos obligatorios-->
            * Este BOCETO todavía<br />no guarda ningún dato
          </p>
        </div>
      </div>
    </form>
  </div>
</div>
